<template>
  <div class="main-container">
    <div v-if="submittedOrder && submittedOrder.is_table">
      <active-order v-if="submittedOrder && submittedOrder.status !== 'FINAL BILL'" :order="submittedOrder"
        :settings="clientSettings" :language="selectedLanguage" @call-a-waiter="callAWaiterHandler"
        @bill-request="billRequestHandler" />
      <submitted-order v-if="submittedOrder && submittedOrder.status === 'FINAL BILL'"
        :settings="clientSettings"
        @call-a-waiter="callAWaiterHandler"
        @submit-review="submitReview($event)" />
    </div>
    <div v-else-if="submittedOrder">
      <submitted-order v-if="submittedOrder && submittedOrder.status === 'DELIVERED'"
        @submit-review="submitReview($event)" />
      <div v-else>
        <div class="order">
          <div class="top-navbar">
            <div class="main-container">
              <div class="row">
                <div class="col-auto">
                  <router-link to="/" tag="button" class="top-navbar__back" typeof="submit" >
                    <i class="icon-angle-left"></i>
                    {{ t('message["Home Page"]', 'Home Page') }}
                  </router-link>
                </div>
                <div class="col-auto ml-auto">

                </div>
              </div>
            </div>
          </div>
          
          <!-- <div class="n-modal__inner">
            <div class="n-modal__cont">
              <div class="n-modal__title">{{ t('message["Items from Order #"]', 'Items from Order #') }}{{submittedOrder.id}}</div>
              <div class="n-modal__place"><i class="icon-place"></i> 856 Esta Underpass</div>
              
              <div class="table-responsive">
                <table class="table-total">
                  <tbody v-if="submittedOrder.products">
                    <tr v-for="item in submittedOrder.products" :key="item.order_price">
                      <td class="table-total__name">{{ item.product[0].name[selectedLanguage.key] }}</td>
                      <td>{{ item.order_quantity }}</td>
                      <td align="right" class="table-total__price">{{ item.order_price * item.order_quantity }} AED</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <div class="separator">
              <div class="separator__inner"></div>
            </div>
            
            <div class="n-modal__cont">
              <div class="total">
                <div class="total__name col-auto">{{ t('message["Total"]', 'Total') }}</div>
                <div class="total__price col-auto ml-auto">{{ submittedOrder.grand_total }} AED</div>
              </div>
            </div>
            
            <div class="separator">
              <div class="separator__inner"></div>
            </div>
            
            <div class="n-modal__cont">
              <div class="n-modal__label">{{ t('message["Shipping Information"]', 'Shipping Information') }}</div>
              <p>{{ submittedOrder.phone }}</p>
              <address>
                {{ submittedOrder.address }}
              </address>
              <div class="n-modal__label">{{ t('message["Notes"]', 'Notes') }}</div>
              <p>{{ submittedOrder.notest }}</p>
            </div>
          </div> -->
          <successfull-order />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import translate from '../../mixins/translate'

  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'

  import {
    callAWaiter
  } from '../../services/client'

  import {
    billRequest,
    leftOrderReview,
  } from '../../services/products'

  import SubmittedOrder from './SubmittedOrder'
  import ActiveOrder from './ActiveOrder'
  import SuccessfullOrder from './SuccessfullOrder'

  export default {
    mixins: [translate],
    components: {
      SubmittedOrder,
      ActiveOrder,
      SuccessfullOrder,
    },
    computed: {
      ...mapState('settings', ['selectedLanguage', 'clientSettings', 'tableNumber']),
      ...mapState('cart', ['cartProducts', 'submittedOrder']),
      proccessLineWidthTableOrder() {
        if (this.submittedOrder.status === 'ACCEPTED') return '50%'
        if (this.submittedOrder.status === 'FINAL BILL') return '100%'
        return 0
      },
      proccessLineWidthOnlineOrder() {
        if (this.submittedOrder.status === 'ACCEPTED') return '33.33%'
        if (this.submittedOrder.status === 'SHIPPED') return '66.66%'
        if (this.submittedOrder.status === 'DELIVERED') return '100%'
        return 0
      }
    },
    mounted() {
      if (!this.submittedOrder && this.$route.params.id) {
        this.getOrderInfo(this.$route.params.id);
      }
    },
    destroyed() {
      if (this.submittedOrder.status === 'FINAL BILL') {
        this.setEmptySubmittedOrder(null)
      }
    },
    methods: {
      ...mapMutations('cart', {
        setSubmittedOrder: 'SET_SUBMITTED_ORDER',
        setEmptySubmittedOrder: 'SET_EMPTY_SUBMITTED_ORDER'
      }),
      ...mapActions('cart', ['getOrderInfo', 'emptyCard']),
      async callAWaiterHandler() {
        const response = await callAWaiter(this.tableNumber)
        this.$notify({
          group: 'app',
          text: response.message
        });
      },
      async billRequestHandler() {
        const response = await billRequest(this.tableNumber, this.submittedOrder.uuid)
        this.$notify({
          group: 'app',
          text: response.message
        });
        this.setSubmittedOrder({
          ...this.submittedOrder,
          ...{
            status: 'FINAL BILL'
          }
        })
        this.emptyCard()
      },
      async submitReview(review) {
        await leftOrderReview(this.submittedOrder.uuid, review);
        this.setSubmittedOrder({
          ...this.submittedOrder,
          ...{
            review,
          }
        })
      }
    }
  }
</script>

<style>
  .horizontal-steps {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
  }

  .horizontal-steps:before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: .2em;
    background-color: #e3eaef;
  }

  .horizontal-steps .horizontal-steps-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
  }

  .horizontal-steps .horizontal-steps-content .step-item:first-child {
    margin-left: 0;
  }

  .horizontal-steps .horizontal-steps-content .step-item {
    display: block;
    position: relative;
    bottom: calc(100% + 1em);
    height: 8px;
    width: 8px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    color: #727cf5;
    background-color: currentColor;
    border: .25em solid #fafbfe;
    border-radius: 50%;
    z-index: 5;
  }

  .horizontal-steps .horizontal-steps-content .step-item.current:before {
    content: '';
    display: block;
    position: absolute;
    top: 47.5%;
    left: 51%;
    padding: 1em;
    background-color: currentColor;
    border-radius: 50%;
    opacity: 0;
    z-index: -1;
    -webkit-animation-name: animation-steps-current;
    animation-name: animation-steps-current;
    -webkit-animation-duration: 2s;
    animation-duration: 2s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  .horizontal-steps .horizontal-steps-content .step-item.current span {
    color: #727cf5;
  }

  .horizontal-steps .horizontal-steps-content .step-item span {
    position: absolute;
    top: calc(100% + 1em);
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    white-space: nowrap;
    color: #adb5bd;
  }

  .horizontal-steps .process-line {
    display: block;
    position: absolute;
    width: 50%;
    height: .2em;
    background-color: #727cf5;
  }
</style>
